export const state = {
  configSteps: []
}

export const mutations = {
  SET_CURRENT_LANGUAGE(state, value) {
    state.currentLang = value
  }
}

export const actions = {
  setCurrentLang({ commit }, value) {
    commit('SET_CURRENT_LANGUAGE', value)
  }
}

export const getters = {}
